import { render, staticRenderFns } from "./uniformCard.vue?vue&type=template&id=bca5ac6e&"
import script from "./uniformCard.vue?vue&type=script&lang=js&"
export * from "./uniformCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports